import { Resizable } from "re-resizable";
import { Button, H4, Intent, TextArea } from "@blueprintjs/core";
import "styled-components/macro";
import React, { useState } from "react";
import { useStoreActions, useStoreState } from "../hooks/ep";

const DEFAULT_NOTE_CONTENTS = "";

export function TripNote({ tripId, humanTripId, showTripNotes }) {
  const storedTripNote = useStoreState((s) => s.tripNotes.initialData)[tripId];
  const handleSubmitTripNote = useStoreActions(
    (a) => a.tripNotes.handleSubmitTripNote
  );
  const [noteContents, setNoteContents] = useState(
    storedTripNote ? storedTripNote.note_contents : DEFAULT_NOTE_CONTENTS
  );
  const dbsyncTripNote = async () => {
    const payload = {
      ...(storedTripNote ?? { trip_id: tripId }),
      note_contents: noteContents,
    };
    console.log("In dbsyncTripNote", { payload });
    await handleSubmitTripNote(payload);
  };
  const onTextareaChange = (ev) => setNoteContents(ev.target.value);
  const dirty =
    noteContents !== (storedTripNote?.note_contents || DEFAULT_NOTE_CONTENTS);
  console.log({ storedNoteContents: storedTripNote, noteContents, dirty });
  return (
    <div
      css={`
        width: 100%;
        padding: 16px;
      `}
    >
      <H4
        css={`
          margin-bottom: 16px;
        `}
      >{`Trip Notes: ${humanTripId}`}</H4>
      <Resizable
        defaultSize={{
          width: 320,
          height: 200,
        }}
      >
        <TextArea
          css={`
            width: 100%;
            height: 100% !important;
            overflow-x: scroll;
            white-space: nowrap;
            overflow-wrap: normal;
            resize: none;
          `}
          // fill={true}
          growVertically={false}
          // large={true}
          intent={Intent.PRIMARY}
          onChange={onTextareaChange}
          value={noteContents}
        />
      </Resizable>
      <div
        css={`
          width: 100%;
          margin-top: 16px;
          display: flex;
          justify-content: space-between;
        `}
      >
        <span>
          <Button
            small
            intent="danger"
            onClick={showTripNotes.setFalse}
            disabled={!dirty}
            css={`
              margin-right: 12px;
            `}
          >
            Cancel
          </Button>
          <Button
            small
            intent={"success"}
            onClick={dbsyncTripNote}
            disabled={!dirty}
          >
            Save
          </Button>
        </span>
        <Button
          small
          intent="primary"
          onClick={showTripNotes.setFalse}
          disabled={dirty}
        >
          Back
        </Button>
      </div>
    </div>
  );
}
